export class MarcheBpuUo {
  constructor(
    public uuid?: string,
    public designation: string = '',
    public prixHt: number = 0,
    public tva: number = 0,
    public prixTtc: number = 0,
    public date?: string | null,
    public marcheBpuUuid?: string,
    public reference: string = '',
    public articleProjet: string = '',
    public unite: number = 1
  ) {}

  static adapt(item: any): MarcheBpuUo {
    return new MarcheBpuUo(
      item.uuid ?? undefined,
      item.designation ?? '',
      item.prixHt ?? 0,
      item.tva ?? 0,
      item.prixTtc ?? 0,
      item.date ?? null,
      item.marcheBpu?.uuid ?? item.marcheBpuUuid ?? undefined,
      item.reference ?? '',
      item.articleProjet ?? '',
      item.unite ?? 1
    );
  }

  static adaptToApi(item: MarcheBpuUo): any {
    return {
      uuid: item.uuid ?? null,
      designation: item.designation,
      prixHt: item.prixHt,
      tva: item.tva,
      date: item.date ?? new Date().toISOString()
    };
  }
}

export class MarcheBpu {
  constructor(
    public uuid: string = '',
    public libelle: string = '',
    public type: string = '',
    public marcheUos: MarcheBpuUo[] = [],
    public dateCreation?: string | null,
    public dateModification?: string | null
  ) {}

  static adapt(item: any): MarcheBpu {
    return new MarcheBpu(
      item.uuid ?? '',
      item.libelle ?? '',
      item.type ?? '',
      (item.marcheUos || item.uos || []).map((uo: any) => MarcheBpuUo.adapt(uo)),
      item.dateCreation ?? null,
      item.dateModification ?? null
    );
  }

  static adaptToApi(item: MarcheBpu): any {
    return {
      uuid: item.uuid ?? null,
      libelle: item.libelle,
      type: item.type
    };
  }
}
